import styled from "@emotion/styled";

import { fontRoboto, theme } from "shared/lib/styles";

import { Figure as AvatarFigure } from "scmp-app/components/author/author-avatar/styles";
import { AvatarContainer } from "scmp-app/components/content/content-author-image/styles";
import { AuthorEntityLink } from "scmp-app/components/content/content-author/styles";
import { H1Container, H2Container } from "scmp-app/components/content/content-headline/styles";
import { StyledGalleryIndicator } from "scmp-app/components/content/content-item-render/styles";
import { EntityLink } from "scmp-app/components/entity-link";
import { Icon as VideoDurationOverlayIcon } from "scmp-app/components/video/video-duration-overlay/variants/homepage/styles";

import ImagePlusFlag from "./img-plus.svg";

export const StyledImagePlusFlag = styled(ImagePlusFlag)`
  margin-block-end: 12px;
`;

export const LiveTagContainer = styled.div`
  &:not(:empty):not(:last-child) {
    margin-block-end: 12px;
  }
`;

export const Header = styled.div`
  grid-area: header;

  display: inline-block;

  margin-block-end: 12px;

  ${H1Container}, ${H2Container} {
    font-weight: 700;
    font-size: 18px;
    font-family: ${fontRoboto};
    line-height: 21px;
    text-overflow: ellipsis;

    ${theme.breakpoints.up("desktop")} {
      font-weight: 700;
      font-size: 20px;
      font-family: ${fontRoboto};
      line-height: 26px;
    }
  }
`;

export const Cover = styled.div`
  grid-area: cover;

  position: relative;

  inline-size: 90px;
  block-size: 60px;

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 150px;
    block-size: 100px;
  }

  figure {
    block-size: unset;
  }

  ${VideoDurationOverlayIcon} {
    display: none;
    ${props => props.theme.breakpoints.up("tablet")} {
      display: block;
    }
  }

  ${StyledGalleryIndicator} {
    display: none;
    ${theme.breakpoints.up("tablet")} {
      display: flex;
    }
  }
`;

export const Authors = styled.div`
  grid-area: authors;

  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  margin-block-end: 12px;

  :empty {
    margin-block-end: 0;
  }

  ${AvatarContainer} {
    margin: 0;
    margin-inline-end: 6px;

    :empty {
      margin-inline-end: 0;
    }
  }

  ${AvatarFigure} {
    inline-size: 20px;
    block-size: 20px;

    border-width: 2px;
  }

  ${AuthorEntityLink} {
    color: #001246;
    font-weight: 700;
    font-size: 12px;
    font-family: ${fontRoboto};
  }
`;

export const Summary = styled.div`
  grid-area: summary;

  display: inline-block;
  display: -webkit-box;

  margin-block-end: 12px;

  color: #333333;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 18px;
  text-overflow: ellipsis;

  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;

  :empty {
    margin-block-end: 0;
  }
`;

export const Footer = styled.div`
  grid-area: footer;

  color: #999999;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 21px;

  time {
    font-size: 12px;
  }
`;

export const PrintHeadline = styled.div`
  grid-area: print-headline;

  margin-block-start: 12px;

  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 14px;

  &:empty {
    display: none;
  }
`;

export const Container = styled.div``;

export const StyledEntityLink = styled(EntityLink)`
  display: grid;
  grid:
    "header . cover" min-content
    "authors . ." min-content
    "summary summary summary" min-content
    "footer footer footer" min-content
    "print-headline print-headline print-headline" min-content
    ". . ." min-content
    / 1fr 12px 90px;

  inline-size: 100%;
  padding-block: 16px;
  box-sizing: border-box;

  cursor: pointer;

  :not(:has(${AvatarContainer}:hover)):not(:has(${AuthorEntityLink}:hover)):hover {
    ${Header} {
      color: #2c4692;
    }
  }

  ${theme.breakpoints.up("tablet")} {
    grid:
      "header . cover" min-content
      "authors . ." min-content
      "summary summary summary" min-content
      "footer footer footer" min-content
      "print-headline print-headline print-headline" min-content
      ". . ." min-content
      / 1fr 20px 150px;
  }

  ${theme.breakpoints.up("desktop")} {
    grid:
      "header . cover" min-content
      "authors . cover" min-content
      "summary . cover" min-content
      "footer . cover" min-content
      "print-headline . cover" min-content
      ". . cover" min-content
      / 1fr 20px 150px;

    padding-block: 20px;
  }
`;
